import { render, staticRenderFns } from "./LPDataTablePagination.vue?vue&type=template&id=161fb3ad&"
import script from "./LPDataTablePagination.vue?vue&type=script&lang=js&"
export * from "./LPDataTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports